/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsIdleOciAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsIdleOciAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsIdleOciAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsIdleOciAdvisorResource>): RecommendationForFinopsIdleOciAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsIdleOciAdvisorResource(), model);
        RecommendationForFinopsIdleOciAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsIdleOciAdvisorResource>): RecommendationForFinopsIdleOciAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsIdleOciAdvisorResource.newInstance(<RecommendationForFinopsIdleOciAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsIdleOciAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsIdleOciAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsIdleOciAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsIdleOciAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
